import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import PaperDraggable from "../../../../../components/PaperDraggable";
import { IFilterState } from ".";

export function FiltroModal({
  open,
  filtros,
  handleClose,
  handleFilterSubmit,
  onClearFilters,
  tarefasOptions
}: FilterModal) {

  const [filters, setFilters] = useState<IFilterState>(filtros);

  //funções manipuladoras
  const handleChangeFilters = (
    prop: keyof IFilterState,
    value: string | string[]
  ) => {
    let valorProp = value

    setFilters((prevState) => ({
      ...prevState,
      [prop]: valorProp,
      pagina: 0
    }));

  };
  //

  return (
    <>
      <Dialog
        id="draggable-dialog-title"
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperComponent={PaperDraggable}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle sx={{ cursor: "move" }}>Filtros</DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ py: 2 }}>

            <Grid size={{xs: 12}}>
              <FormControl fullWidth>
                <InputLabel id="tarefas-select">Tarefa atual</InputLabel>
                <Select
                  labelId="tarefas-select"
                  value={filters.tarefa_atual}
                  label="Tarefa atual"
                  onChange={(e) => handleChangeFilters("tarefa_atual", e.target.value)}
                  renderValue={(selected) => selected.length === 0 ? "Nenhuma tarefa disponível" : selected}
                >
                  {
                    tarefasOptions.length <= 0 &&
                    <MenuItem disabled>
                      Nenhuma tarefa disponível
                    </MenuItem>
                  }

                  {
                    tarefasOptions.length > 0 && tarefasOptions.map((item, index) => <MenuItem key={index} value={item}>{item}</MenuItem>)
                  }
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              onClearFilters();
              handleClose();
            }}
          >
            Limpar
          </Button>

          <Button
            autoFocus
            variant="contained"
            onClick={() => {
              handleFilterSubmit(filters);
              handleClose();
            }}
          >
            Filtrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

interface FilterModal {
  open: boolean;
  filtros: IFilterState;
  handleClose: () => void;
  handleFilterSubmit: (form: IFilterState) => void;
  onClearFilters: () => void;
  tarefasOptions: string[]
}
